export { ProjectsActions } from './projects.actions';
export { ProjectsReducer } from './projects.reducer';
export { ProjectsState } from './projects.state';



// WEBPACK FOOTER //
// ./src/states/v2/projects/index.ts